import { SvgIconComponent } from '@mui/icons-material';
import { SvgIcon, SvgIconProps } from '@mui/material';

const AttackIQLogoIcon: SvgIconComponent = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path d="M12.2929 3.67505C11.7214 3.67505 11.2643 4.02005 10.9214 4.59505C10.8071 4.71005 0.75 19.775 0.75 19.775H3.72144L12.2929 7.12505L16.75 13.7951H11.4929L9.89286 16.0951H18.2357L20.75 19.775H23.7214L13.55 4.59505C13.2072 4.02005 12.8643 3.67505 12.2929 3.67505Z" />
    </SvgIcon>
  );
};

AttackIQLogoIcon.muiName = SvgIcon.muiName;

export { AttackIQLogoIcon };

export const AttackIQLogoColorIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path
        d="M12.2929 3.67505C11.7214 3.67505 11.2643 4.02005 10.9214 4.59505C10.8071 4.71005 0.75 19.775 0.75 19.775H3.72144L12.2929 7.12505L16.75 13.7951H11.4929L9.89286 16.0951H18.2357L20.75 19.775H23.7214L13.55 4.59505C13.2072 4.02005 12.8643 3.67505 12.2929 3.67505Z"
        fill="#9575CD"
      />
    </SvgIcon>
  );
};
